import React from "react";
import { Grid, Typography, Box, makeStyles } from "@material-ui/core";
import { BaseLayout } from "../components";
import { useUserMe } from "../hooks";

const useStyles = makeStyles(theme => ({
  myBadgeContainer: {
    marginBottom: theme.spacing(4),
    margin: "0 auto"
  },
  imageStyle: {
    maxWidth: "100%",
    display: "block",
    margin: "0 auto"
  }
}));

const MyBadgePage = () => {
  const { user } = useUserMe();

  const classes = useStyles();

  return (
    <BaseLayout>
      <Grid container spacing={2} alignItems="center" justify="center">
        <Grid item xs={12} sm={10} md={8}>
          <Box textAlign="center" px={2} my={2}>
            <Typography variant="h4">
              <strong>
                {user?.profile?.firstName} {user?.profile?.lastName}
              </strong>
            </Typography>
          </Box>
          <Box textAlign="center" px={2} mb={2}>
            <Typography variant="h5">{user?.profile?.affiliation}</Typography>
            <Typography variant="h5">{user?.profile?.roleDescription}</Typography>
          </Box>
          {user.qrcode && (
            <Box textAlign="center" p={2} px={2} className={classes.myBadgeContainer}>
              <img src={user.qrcode} alt="qrcode" className={classes.imageStyle} />
            </Box>
          )}
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default MyBadgePage;
